import { NewVersionPopup as SourceNewVersionPopup } from 'SourceComponent/NewVersionPopup/NewVersionPopup.component';

import './NewVersionPopup.style';

/** @namespace Pwa/Component/NewVersionPopup/Component */
export class NewVersionPopup extends SourceNewVersionPopup {
    renderNotice() {
        return <p>{__('We have made improvements to our store. Page refresh needed')}</p>;
    }

    renderReloadThePageButton() {
        const { toggleNewVersion } = this.props;

        return (
            <button block="NewVersionPopup" elem="ReloadButton" mix={{ block: 'Button' }} onClick={toggleNewVersion}>
                {__('Close')}
            </button>
        );
    }

    renderButtons() {
        return (
            <div block="NewVersionPopup" elem="Buttons">
                {this.renderReloadThePageButton()}
            </div>
        );
    }
}

export default NewVersionPopup;
